import http from "../../utils/httpClient";

class parcelDeliveryService {
    // Parcel Delivery Service Start
    getDeliveryInfoData = async (query) => {
        return await http.get(
            `/api/Order/GetDeliveryInfoData`, { params: query }
        );
    };

    createOrUpdateParcelDeliveryData = async (data) => {
        return await http.post("/api/v2/Ads/AddOrEditAdsType", data)
      };
    // Parcel Delivery Service End
}

export default new parcelDeliveryService();